import React from 'react';
import BaseDialog from './BaseDialog';
import Button from './Button';

/**
 * ConfirmDialog Component
 * 
 * A reusable confirmation dialog for confirming actions
 * 
 * @param {boolean} isOpen - Controls dialog visibility
 * @param {string} title - Dialog title
 * @param {string} message - Confirmation message
 * @param {function} onConfirm - Callback when user confirms
 * @param {function} onCancel - Callback when user cancels
 * @param {boolean} loading - Loading state for async operations
 * @param {string} confirmText - Text for confirm button (default: "Delete")
 * @param {string} cancelText - Text for cancel button (default: "Cancel")
 * @param {string} confirmVariant - Variant for confirm button ('primary', 'danger') (default: "danger")
 */
const ConfirmDialog = ({
  isOpen,
  title = 'Confirm deletion',
  message,
  onConfirm,
  onCancel,
  loading = false,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  confirmVariant = 'danger',
}) => {
  if (!isOpen) return null;

  const footer = (
    <>
      <Button variant="secondary" onClick={onCancel} disabled={loading}>
        {cancelText}
      </Button>
      <Button variant={confirmVariant} onClick={onConfirm} disabled={loading}>
        {loading ? 'Processing...' : confirmText}
      </Button>
    </>
  );

  return (
    <BaseDialog
      isOpen={isOpen}
      title={title}
      onClose={onCancel}
      footer={footer}
      size="small"
    >
      <p className="text-sm text-gray-700">{message}</p>
    </BaseDialog>
  );
};

export default ConfirmDialog;

